/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { styles } from './JobsListExpand.styles';
import { Job } from '../../api/JobsApi';
import CollapsedJob from '../CollapsedJob/CollapsedJob';
import ExpandedJob from '../ExpandedJob/ExpandedJob';

interface Props {
  jobs: Job[];
}

export default function JobsListExpand({ jobs }: Props) {
  const [selectedId, setSelectedId] = useState<number | null>(null);

  return (
    <div css={styles.list}>
      {jobs.map(job => {
        const isOpen = selectedId === job.id;

        return (
          <div
            key={job.id}
            css={styles.card}
            onClick={() =>
              setSelectedId(prev => (prev === job.id ? null : job.id))
            }
          >
            {isOpen ? <ExpandedJob job={job} /> : <CollapsedJob job={job} />}
          </div>
        );
      })}
    </div>
  );
}
